function selectSize(button, value) {

  console.log('Selected size:', value);

  // Update active state
  document.querySelectorAll('.gv-size-btn').forEach(b => b.classList.remove('active'));
  button.classList.add('active');

  // Update selected size label
  document.getElementById('selected-size').textContent = '— ' + value;

  const variantId = button.getAttribute('data-variant-id');

  // Update hidden form input and add to bag variant ID
  document.querySelector('form [name="id"]').value = variantId;
  const addBtn = document.querySelector('.gv-add-to-bag');
  addBtn.setAttribute('data-variant-id', variantId);

  // Set loading state while checking
  addBtn.disabled = true;
  addBtn.textContent = 'Checking...';

  const productHandle = window.location.pathname.split('/products/')[1].split('?')[0];

  Promise.all([
    fetch(`/products/${productHandle}.js`).then(r => r.json()),
    fetch('/cart.js').then(r => r.json())
  ])
  .then(([product, cart]) => {
    const variant = product.variants.find(v => v.id == variantId);
    const cartItem = cart.items.find(item => item.variant_id == variantId);
    const qtyInCart = cartItem ? cartItem.quantity : 0;
    const inventoryQty = parseInt(button.getAttribute('data-inventory_quantity')) || 0;

    console.log('variant:', variant.title);
    console.log('available:', variant.available);
    console.log('qty in cart:', qtyInCart);
    console.log('inventory qty:', inventoryQty);

    const effectivelySoldOut = !variant.available || qtyInCart >= inventoryQty;
   
    if (effectivelySoldOut) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
      button.classList.add('gv-size-btn--sold-out');
      button.disabled = true;
      console.log('SoldOut: Yes');
      
      // Find next available and switch to it
      document.querySelectorAll('.gv-size-btn').forEach(b => b.classList.remove('active'));
      const nextAvailable = document.querySelector('.gv-size-btn:not([disabled]):not(.gv-size-btn--sold-out)');
      if (nextAvailable) {
        nextAvailable.classList.add('active');
        console.log('Switching active to:', nextAvailable.textContent.trim());
        selectSize(nextAvailable, nextAvailable.textContent.trim());
      } else {
        console.log('All sizes sold out');
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
    } else {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Bag';
      button.classList.remove('gv-size-btn--sold-out');
      button.disabled = false;
      console.log('SoldOut: No');
    }

    const inventoryEl = document.getElementById('gv-inventory-count');  // ✅
    if (inventoryEl) {
      if (inventoryQty > 0 && inventoryQty <= 5) {
        inventoryEl.textContent = `Only ${inventoryQty} left`;
      } else {
        inventoryEl.textContent = '';
      }
    }
  })
  .catch(err => {
    console.error('Stock check failed:', err);
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Bag';
  });
}

function addToBag(button) {

  const form = button.closest('form');
  const variantInput = form ? form.querySelector('[name="id"]') : null;
  const variantId = variantInput ? variantInput.value : button.getAttribute('data-variant-id');

  console.log('variantId:', variantId);
  if (!variantId) {
    console.error('No variant ID found');
    return;
  }

  button.disabled = true;
  button.textContent = 'Checking...';

  fetch(`/variants/${variantId}.js`)
    .then(response => response.json())
    .then(variant => {
      console.log('Variant data:', variant);
      console.log('Available:', variant.available);

      if (!variant.available) {
        button.textContent = 'Sold Out';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = 'Add to Bag';
        }, 2000);
        return Promise.reject('out_of_stock');
      }

      button.textContent = 'Adding...';
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    })
    .then(response => response.json())
    .then(() => {
      button.textContent = 'Added!';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = 'Add to Bag';

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const count = cart.item_count;
            const label = count === 1 ? 'item' : 'items';

            const drawerCount = document.getElementById('gv-cart-count');
            if (drawerCount) drawerCount.textContent = `(${count} ${label})`;

            const navBadge = document.getElementById('cart-count');
            if (navBadge) navBadge.textContent = count;

            refreshCartDrawer();

            // Directly call selectSize on active button
            const activeBtn = document.querySelector('.gv-size-btn.active');
            if (activeBtn) {
              selectSize(activeBtn, activeBtn.textContent.trim());
            }
          });
      }, 2000);
    })
    .catch(error => {
      if (error === 'out_of_stock') return;
      console.error('Add to bag error:', error);
      button.textContent = 'Error — try again';
      button.disabled = false;
    });
}

function refreshCurrentVariant() {
  console.log('refreshCurrentVariant called');

  const activeBtn = document.querySelector('.gv-size-btn.active')
    || document.querySelector('.gv-size-btn:not([disabled])');

  if (!activeBtn) {
    console.log('No available sizes on load');
    const addBtn = document.querySelector('.gv-add-to-bag');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
    }
    return;
  }

  activeBtn.classList.add('active');
  console.log('On load — checking:', activeBtn.textContent.trim());
  selectSize(activeBtn, activeBtn.textContent.trim());
}


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(refreshCurrentVariant, 500);
  });
} else {
  setTimeout(refreshCurrentVariant, 500);
}